<template>
      <div class="backRoot">
                <i @click="goBack" class="el-icon-arrow-left iconItme" style="width: 100%;height: 100%;"></i>
            </div>
    
</template>

<script>
import { method } from 'lodash';

export default {
    props:['currentIndex'],
    data(){
      return{
      }
    },
    mounted: function() {
      let per = Math.ceil(this.currentIndex/7*100)
      this.persent =  per>100?100:per
    },
    methods:{
        goBack(){
            console.log('gpbadd')
            // this.currentPage = this.currentPage -1
            this.$emit('backPreviewPage')
        },
    }
}
</script>

<style lang="scss">
.backRoot{
    width: 100%;
    height: 100%;
            .iconItme{
                cursor: pointer;
                font-size: 30px;
            }
            .iconItme:hover{
                color: #feae00;
            }
            .iconItme:active{
                color: #feae00;
            }
        }

@media screen and (max-width:767px) { 
    .backRoot{
                // position: absolute;
                // left: 2vw;
                // top: 3vw;
                // display: inline-block;
                .iconItme{
                    cursor: pointer;
                    font-size: 6vw;
                }
            }
        }
@media screen  and (min-width: 767px) and (max-width: 1200px){
    .backRoot{
                // position: absolute;
                // left: 6vw;
                // top: 2vw;
                // display: inline-block;
                .iconItme{
                    cursor: pointer;
                    font-size: 3vw;
                }
            }
        }
</style>